import Layout from "../../components/Layout";
import AdminCollectionTable, { formatMoney } from "../../components/AdminCollectionTable";

const COLUMNS = [
  { key: "full_name",     label: "Full Name",            path: "FullName",           sortable: true, sortPath: "FullName" },
  { key: "email",         label: "Email",                path: "Email",              sortable: true, sortPath: "Email" },
  { key: "phone",         label: "Phone",                path: "Phone",              sortable: true, sortPath: "Phone" },
  { key: "vip_level",     label: "VIP Level",            path: "ShortVIPLevel",      sortable: true, sortPath: "ShortVIPLevel" },
  { key: "company",       label: "Company",              path: "Company",            sortable: true, sortPath: "Company" },
  { key: "postcode",      label: "Postcode",             path: "PostCode",           sortable: true, sortPath: "PostCode" },
  { key: "num_orders",    label: "# Orders",             path: "NumberOfOrders",     sortable: true, sortPath: "NumberOfOrders" },
  { key: "total_value",   label: "Total Value",          path: "TotalOrdersValue",   sortable: true, sortPath: "TotalOrdersValue", formatter: formatMoney },
  { key: "avg_value",     label: "Average Order Value",  path: "AverageOrderValue",  sortable: true, sortPath: "AverageOrderValue", formatter: formatMoney },
  { key: "last_order",    label: "Last Order Date",      path: "LastOrderDate",      sortable: true, sortPath: "LastOrderDate" },
];

export default function PersonManagement() {
  return (
    <Layout>
      <AdminCollectionTable
        collectionName="persons"
        title="Persons"
        subtitle="Pipedrive Persons"
        columns={COLUMNS}
        alphaField="FullName"
      />
    </Layout>
  );
}
